import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const quickbooksService = {
  /**
   * Get QuickBooks authentication status
   * @returns {Promise} Response with authentication status
   */
  getStatus: () => api.getCall("/api/quickbooks/status"),

  /**
   * Initiate QuickBooks OAuth flow
   * Opens QuickBooks authorization page in a new window
   * @param {string} connectionType - 'production' or 'sandbox' (optional, defaults to 'production')
   */
  initiateAuth: (connectionType = 'production') => {
    const apiBaseUrl = process.env.VUE_APP_API_URL || window.location.origin;
    const authUrl = `${apiBaseUrl}/api/quickbooks/auth?connectionType=${connectionType}`;

    // Open in a new window with specific dimensions
    const width = 600;
    const height = 700;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    const title = connectionType === 'sandbox' ? 'QuickBooks Sandbox OAuth' : 'QuickBooks OAuth';

    window.open(
      authUrl,
      title,
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`
    );
  },

  /**
   * Disconnect from QuickBooks
   * @param {string} connectionType - 'production' or 'sandbox' (optional, defaults to 'production')
   * @returns {Promise} Response with success status
   */
  disconnect: (connectionType = 'production') => {
    return api.postCall("/api/quickbooks/disconnect", { connectionType });
  },

  /**
   * Send invoice to QuickBooks
   * @param {number} authorizationId - The authorization ID
   * @param {number} month - Month (1-12)
   * @param {number} year - Year (e.g., 2025)
   * @param {string} connectionType - 'production' or 'sandbox' (optional, defaults to 'production')
   * @returns {Promise} Response with QuickBooks invoice details
   */
  sendInvoice: (authorizationId, month, year, connectionType = 'production') => {
    return api.postCall("/api/quickbooks/send-invoice", {
      authorizationId,
      month,
      year,
      connectionType
    });
  },

  /**
   * Get QuickBooks invoice information for a specific authorization/month/year
   * @param {number} authorizationId - The authorization ID
   * @param {number} month - Month (1-12)
   * @param {number} year - Year (e.g., 2025)
   * @returns {Promise} Response with QuickBooks invoice information or null if not sent
   */
  getInvoiceInfo: (authorizationId, month, year) => {
    return api.getCall(`/api/quickbooks/invoice/${authorizationId}/${month}/${year}`);
  },

  /**
   * Send Job Development documents to office via email
   * @param {number} authorizationId - The authorization ID
   * @param {number} month - Month (1-12)
   * @param {number} year - Year (e.g., 2026)
   * @returns {Promise} Response with send result
   */
  sendToOffice: (authorizationId, month, year) => {
    return api.postCall("/api/quickbooks/send-to-office", {
      authorizationId,
      month,
      year
    });
  }
};
